import Vue from 'vue'
import Vuex from 'vuex'
import { Menu } from "@/modules/Menu";
import { MainteInfo } from "@/modules/MainteInfo";
import { SheetListCondition } from "@/modules/teacher/SheetList";
import { SearchCondition as WebupListCondition } from "@/modules/teacher/WebupList"
import { SearchCondition as BaseSheetListCondition } from "@/modules/teacher/BaseSheetList"
import { SearchCondition as StudentListCondition } from "@/modules/teacher/CramStudentList"
import { SheetListCondition as StudentSheetListCondition } from "@/modules/student/SheetList"
import createPersistedState from 'vuex-persistedstate';
import * as Common from '../commons/common';
import router from "@/router/index";
import isMobileJS from 'ismobilejs'

Vue.use(Vuex)

export type StateType = {
  currentUser: any
  isShowOverlay: boolean
  overlayText: string
  schools: any[]
  curriculums: any[]
  grades: any[]
  months: any[]
  roles: any[]
  levels: any[]
  rooms: any[]
  events: any[]
  course_types: any[]
  sheetType: number
  sheetListCondition: SheetListCondition
  webupListCondition: WebupListCondition
  baseSheetListCondition: BaseSheetListCondition
  studentListCondition: StudentListCondition
  studentSheetListCondition: StudentSheetListCondition
  isMobile: boolean
  isHeaderDisp: boolean
  mainteInfo: MainteInfo
  isPendingOnly: boolean
  cram_student_id: number
  webup_type: number
  cram_student: any
  isKaitouViewReloaded: boolean
  isShowingMsgBox: boolean
  event_code: string
}

export default new Vuex.Store({
  state: {
    currentUser: null,
    isShowOverlay: false,
    overlayText: "",
    schools: [],
    curriculums: [],
    grades: Common.GetComboboxGradeArray(),
    months: Common.GetComboboxMonthArray(),
    roles: Common.GetComboboxRoleArray(),
    levels: Common.GetComboboxLevelArray(),
    course_types: Common.GetComboboxCourseTypeArray(),
    rooms: [],
    events: [],
    sheetType: 0,
    sheetListCondition: new SheetListCondition(),
    webupListCondition: new WebupListCondition(),
    baseSheetListCondition: new BaseSheetListCondition(),
    studentListCondition: new StudentListCondition(),
    studentSheetListCondition: new StudentSheetListCondition(),
    isMobile: isMobileJS(navigator.userAgent).any,
    isHeaderDisp: true,
    mainteInfo: new MainteInfo([]),
    cram_student_id: null,
    webup_type: null,
    isKaitouViewReloaded: false,
    isShowingMsgBox: false,
    event_code: null,
  } as StateType,
  mutations: {
    setCurrentUser(state, user: any){
      state.currentUser = user;
    },
    setCurrentUserSchoolId(state, school_id: any){
      state.currentUser.school_id = school_id;
    },
    setCurrentUserSchoolOptions(state, school_options: any){
      state.currentUser.school_options = school_options;
    },
    setSchools(state, schools: []){
      state.schools = schools;
    },
    setCurriculums(state, curriculums: []){
      state.curriculums = curriculums;
    },
    setRooms(state, rooms: []){
      state.rooms = rooms;
    },
    setEvents(state, events: []){
      state.events = events;
    },
    setSheetListCondition(state, condition: SheetListCondition){
      state.sheetListCondition = condition;
    },
    setWebupListCondition(state, condition: WebupListCondition){
      state.webupListCondition = condition;
    },
    setBaseSheetListCondition(state, condition: BaseSheetListCondition){
      state.baseSheetListCondition = condition;
    },
    setStudentListCondition(state, condition: StudentListCondition){
      state.studentListCondition = condition;
    },
    setStudentSheetListCondition(state, condition: StudentSheetListCondition){
      state.studentSheetListCondition = condition;
    },
    setIsShowOverlay(state, isShow: boolean){
      state.isShowOverlay = isShow;
    },
    setOverlayText(state, text: string){
      state.overlayText = text;
    },
    setSheetType(state, sheetType: number){
      state.sheetType = sheetType;
    },
    setIsHeaderDisp(state, isHeaderDisp: boolean){
      state.isHeaderDisp = isHeaderDisp;
    },
    setMainteInfo(state, mainteInfos: any[]){
      state.mainteInfo = new MainteInfo(mainteInfos);
    },
    setIsPendingOnly(state, isPendingOnly){
      state.isPendingOnly = isPendingOnly;
    },
    setCramStudentId(state, cram_student_id){
      state.cram_student_id = cram_student_id;
    },
    setWebupType(state, webup_type){
      state.webup_type = webup_type;
    },
    setCramStudent(state, cram_student){
      state.cram_student = cram_student;      
    },
    setIsKaitouViewReloaded(state, value){
      state.isKaitouViewReloaded = value;
    },
    setIsShowingMsgBox(state, isShowingMsgBox: boolean){
      state.isShowingMsgBox = isShowingMsgBox;
    },
    setEventCode(state, event_code: string){
      state.event_code = event_code;
    },
  },
  getters: {
    // 教科プルダウン
    getComboboxCurriculums: (state) => (allowEmpty: boolean, event_code: number = null) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      const curriculums = event_code ? state.curriculums.filter((x: any) => x.event_codes.includes(event_code)) : state.curriculums;
      for(const curriculum of curriculums){
        rtn.push({value: curriculum.id, text: curriculum.name});
      }
      return rtn;
    },
    // 自分の担当教科プルダウン
    getComboboxMyCurriculums: (state) => (allowEmpty: boolean, event_code: number = null) => {
      const rtn: any[] = [];
      if(state.currentUser.role == "teacher2"){
        const curriculum_ids = state.currentUser.curriculum_id.split(",");
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const curriculum of state.curriculums){
          if(curriculum_ids.includes(`${curriculum.id}`) && curriculum.event_codes.includes(event_code)){
            rtn.push({value: curriculum.id, text: curriculum.name});
          }
        }
      }else{
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        const curriculums = event_code ? state.curriculums.filter((x: any) => x.event_codes.includes(event_code)) : state.curriculums;
        for(const curriculum of curriculums){
          rtn.push({value: curriculum.id, text: curriculum.name});
        }
      }
      return rtn;
    },
    // 教室プルダウン
    getComboboxRooms: (state) => (allowEmpty: boolean, includeDisableRoom: boolean = false) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const room of state.rooms){
        if(!includeDisableRoom && room.status == 1){
          continue;
        }
        rtn.push({value: room.room_code, text: `${room.room_code}:${room.name}`});
      }
      return rtn;
    },
    // 実施月プルダウン
    getComboboxMonths: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.months);
    },
    // 学校プルダウン
    getComboboxSchools: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const school of state.schools){
        rtn.push({value: school.id, text: school.name});
      }
      return rtn;
    },
    // 学年プルダウン
    getComboboxGrades: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.grades);
    },
    // イベントプルダウン
    getComboboxEvents: (state) => (allowEmpty: boolean, includeDisableRoom: boolean = false) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const event of state.events){
        rtn.push({value: event.event_code, text: `${event.name}`});
      }
      return rtn;
    },
    // VSHプルダウン
    getComboboxLevels: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.levels);
    },
    getCurriculumNameById: (state) => (id: number) => {
      const curriculum = state.curriculums.filter(x => x.id == id);
      return curriculum.length > 0 ? curriculum[0].name : "-";
    },
    getGradeNameByValue: (state) => (value: number) => {
      const grade = state.grades.filter(x => x.value == value);
      return grade.length > 0 ? grade[0].text : "-";
    },
    getComboboxRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.roles);
    },
    getComboboxCourseTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.course_types);
    },
    getRoleNameByValue: (state) => (value: string) => {
      const role = state.roles.filter(x => x.value == value);
      return role.length > 0 ? role[0].text : "-";
    },
    getCourseTypeNameByValue: (state) => (value: string) => {
      const course_type = state.course_types.filter(x => x.value == value);
      return course_type.length > 0 ? course_type[0].text : "-";
    },
    getEventNameByCode: (state) => (event_code: number) => {
      const event = state.events.filter(x => x.event_code == event_code);
      return event.length > 0 ? event[0].name : "-";
    },
    // ヘッダメニュー 権限・オプションにより制御
    headerMenus: (state, getters) => {
      
      const menus: Menu[] = new Array<Menu>();
      
      if(state.currentUser == null){
        return menus;
      }

      menus.push(new Menu("ユーザー管理", "address-card", "/teacher_site/user_edit"));
      menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
      if(state.currentUser.role == Common.RoleEnum.Admin || (state.currentUser.role == Common.RoleEnum.Teacher1 && state.currentUser.school_id == 2)){
        menus.push(new Menu("試験マスタ管理", "file-invoice", "/teacher_site/base_sheet_list"));
      }
      
      if(state.currentUser.aggregate_auth){
        menus.push(new Menu("集計一覧", "file-alt", "/teacher_site/sumup_list"));
        menus.push(new Menu("得点変更ログ出力", "download", "/teacher_site/score_change_log_list"));
      }

      if(state.currentUser.broese_auth){
        menus.push(new Menu("生徒成績一覧", "graduation-cap", "/teacher_site/student_list"));
        menus.push(new Menu("生徒成績出力", "download", "/teacher_site/sumup_result_download"));
      }

      if(state.currentUser.role == Common.RoleEnum.Admin){
        menus.push(new Menu("学校一覧", "calendar-alt", "/teacher_site/school_list"));
      }

      if(state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1){
        menus.push(new Menu("教師一覧", "graduation-cap", "/teacher_site/teacher_list"));
        menus.push(new Menu("マスタ管理", "file-invoice", "/teacher_site/room_list"));
      }

      // 開発用 ローカル端末のみ表示
      if(state.currentUser.role == Common.RoleEnum.Admin && window.location.href.indexOf("http://localhost:8080/#/") != -1){
        menus.push(new Menu("QR付き画像生成", "file-invoice", "/teacher_site/qr_base_sheet_upload"));
        menus.push(new Menu("ダミー試験生成", "file-invoice", "/teacher_site/dummy_base_sheet_edit"));
      } 

      return menus;
    },
    // システム管理者か判定
    isAdmin: state => {
      return state.currentUser.role == Common.RoleEnum.Admin;
    },
  },
  actions: {
    showOverlay(context, overlayText){
      context.commit("setIsShowOverlay", true);
      context.commit("setOverlayText", overlayText == null ? "処理実行中... しばらくお待ちください。" : overlayText);
    },
    hideOverlay(context){
      context.commit("setIsShowOverlay", false);
    },
    goSheetList(){
      router.push('/teacher_site/sheet_list');
    },
    goBaseSheetList(){
      router.push('/teacher_site/base_sheet_list');
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
})
